export default __webpack_public_path__ + "3d3352d44ba3733f010519a8cc65fda8.jpeg";